export default "__VITE_ASSET__67d7a19a__"